// Phred quality score Q relates to the base-calling error probability P by
//   P = 10^(-Q/10)   and   Q = -10 * log10(P).

export function qToP(q: number): number {
  return 10 ** (-q / 10);
}

export function pToQ(p: number): number | null {
  if (!(p > 0) || p > 1) return null;
  return -10 * Math.log10(p);
}

/** Base-call accuracy as a percentage, (1 - P) × 100. */
export function qToAccuracy(q: number): number {
  return (1 - qToP(q)) * 100;
}

/** ASCII quality character for a score, given the encoding offset (33 or 64). */
export function qToChar(q: number, offset = 33): string {
  const code = Math.round(q) + offset;
  if (code < 33 || code > 126) return "";
  return String.fromCharCode(code);
}

/** Decode an ASCII quality string to per-base Q scores. */
export function decodeQualityString(s: string, offset = 33): number[] {
  return [...s].map((ch) => ch.charCodeAt(0) - offset);
}
